/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Caption_Track_HelpInputs */

const en_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the caption track to embed`)
};

const fr_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez la piste de sous-titres a incruster`)
};

const de_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die einzubettende Untertitelspur aus.`)
};

const it_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la traccia dei sottotitoli da incorporare`)
};

const ru_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите дорожку субтитров для встраивания.`)
};

const es_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione la pista de subtítulos que desea incrustar`)
};

const zh_cn2_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要嵌入的字幕轨道。`)
};

const ja_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`埋め込むキャプショントラックを選択してください`)
};

const hi_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन ट्रैक का चयन करें जिसे आप एम्बेड करना चाहते हैं`)
};

const pt_pt2_embed_captions_caption_track_help = /** @type {(inputs: Embed_Captions_Caption_Track_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a faixa de legenda que deseja incorporar.`)
};

/**
* | output |
* | --- |
* | "Select the caption track to embed" |
*
* @param {Embed_Captions_Caption_Track_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_caption_track_help = /** @type {((inputs?: Embed_Captions_Caption_Track_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Caption_Track_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_caption_track_help(inputs)
	if (locale === "de") return de_embed_captions_caption_track_help(inputs)
	if (locale === "it") return it_embed_captions_caption_track_help(inputs)
	if (locale === "ru") return ru_embed_captions_caption_track_help(inputs)
	if (locale === "es") return es_embed_captions_caption_track_help(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_caption_track_help(inputs)
	if (locale === "ja") return ja_embed_captions_caption_track_help(inputs)
	if (locale === "hi") return hi_embed_captions_caption_track_help(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_caption_track_help(inputs)
	return en_embed_captions_caption_track_help(inputs)
});